document.addEventListener('DOMContentLoaded', () => {

    const animationBox = document.querySelector(
        '#shopify-section-template--26324827898233__image_banner_AEfL4g .animation-box'
    );
    if (!animationBox) return;
    const titleText = animationBox.querySelector('.box-title-text');
    const fadeTimes = [0.5, 2, 3.5, 5, 6.5];

    function fadeAndSwap(newLabel) {
        titleText.classList.add("fading");

        setTimeout(() => {
            titleText.textContent = newLabel;
            titleText.classList.remove("fading");
            titleText.classList.add("glow-now");
        }, 300); // fade-out time
    }
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    animationBox.classList.add('active');
                    observer.unobserve(animationBox);
                    setTimeout(() => {
                        fadeAndSwap("5% Discount");
                    }, fadeTimes[1] * 1000);
                    setTimeout(() => {
                        fadeAndSwap("10% Discount");
                    }, fadeTimes[2] * 1000);
                }
            });
        },
        { threshold: 0.3 }
    );

    observer.observe(animationBox);
});


function attachProductPageButtons() {

    // Re-select fresh DOM nodes after variant change
    const openBtn = document.querySelector(".share");
    const popup = document.querySelector(".share-popup");
    const overlay = document.querySelector(".share-popup-overlay");
    const closeBtn = document.querySelector(".share-popup-close");

    // --- SHARE ---
    if (openBtn && popup && overlay && closeBtn) {

        // remove old listeners
        openBtn.onclick = null;
        overlay.onclick = null;
        closeBtn.onclick = null;

        openBtn.onclick = () => {
            popup.style.display = "block";
            overlay.style.display = "block";
            document.body.classList.add("no-scroll");
        };

        const close = () => {
            popup.style.display = "none";
            overlay.style.display = "none";
            document.body.classList.remove("no-scroll");
        };

        closeBtn.onclick = close;
        overlay.onclick = close;
    }

    // --- WISHLIST ---
    const heart = document.querySelector(".heart");

    if (heart) {

        heart.onclick = null;

        const product = {
            handle: heart.dataset.productHandle,
            title: heart.dataset.productTitle,
            url: heart.dataset.productUrl,
            image: heart.dataset.productImage
        };

        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        if (wishlist.find(i => i.handle === product.handle)) {
            heart.classList.add("filled");
        }

        heart.onclick = () => {
            const exists = wishlist.find(i => i.handle === product.handle);

            if (exists) {
                wishlist = wishlist.filter(i => i.handle !== product.handle);
                heart.classList.remove("filled");
            } else {
                wishlist.push(product);
                heart.classList.add("filled");
            }

            localStorage.setItem("wishlist", JSON.stringify(wishlist));
        };
    }
}

document.addEventListener("DOMContentLoaded", attachProductPageButtons);

const variantWatcher = new MutationObserver(() => {
    attachProductPageButtons();
});

variantWatcher.observe(document.body, {
    childList: true,
    subtree: true
});




function getURLParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

let bundleItems = [];

function saveBundle() {
    sessionStorage.setItem("bundleItems", JSON.stringify(bundleItems));
}

document.addEventListener("DOMContentLoaded", () => {
    if (!document.body.classList.contains("bundle-builder-active")) {
        console.log("Bundle JS disabled on this page.");
        return;
    }
    const bundleItemsContainer = document.querySelector("#bundle-items");
    const bundleSummaryContent = document.querySelector("#bundle-summary-content");

    const getCardByHandle = handle =>
        document.querySelector(`[data-product-handle="${handle}"]`);

    const renderBundle = () => {
        const MAX_SLOTS = 3;
        let html = "";
        let usedSlots = 0;

        bundleItems.forEach(item => {
            // Ensure per-unit out-of-stock array exists
            const flags = item.unitOutOfStock || [];

            for (let i = 0; i < item.qty; i++) {

                const unitOut = !!flags[i]; // true/false per slot
                usedSlots++;

                html += `
                <div class="bundle-slot filled fade-in ${unitOut ? "bundle-out-of-stock" : ""}">
                    <div class="bundle-slot-inner">
                        <button class="bundle-remove-x" data-variant-id="${item.variantId}">×</button>
                        <img src="${item.image}" class="bundle-slot-image">

                        ${unitOut ? `<div class="bundle-warning-tag">No longer available</div>` : ""}
                    </div>
                </div>
            `;
            }
        });

        // Fill empty slots
        const emptySlots = MAX_SLOTS - usedSlots;
        for (let i = 0; i < emptySlots; i++) {
            html += `
            <div class="bundle-slot empty">
                <div class="bundle-slot-placeholder">
                    <span class="bundle-slot-plus">+</span>
                </div>
            </div>
        `;
        }

        bundleItemsContainer.innerHTML = html;
    };



    const renderSummaryThumbnails = () => {
        if (!bundleItems.length)
            return `<div class="bundle-summary-thumbs empty">No items yet</div>`;

        return `
            <div class="bundle-summary-thumbs">
                ${bundleItems.map(i => `<img src="${i.image}" class="bundle-thumb">`).join("")}
            </div>
        `;
    };

    const renderProgressBar = count => {
        let percent = 0;
        let label = "";

        if (count === 0) {
            percent = 0;
            label = "Add items to unlock discounts";
        } else if (count < 3) {
            percent = (count / 3) * 100;
            label = `Add ${3 - count} more items for 5% off`;
        } else if (count < 5) {
            percent = ((count - 3) / 2) * 100;
            label = `Add ${5 - count} more items for 10% off`;
        } else {
            percent = 100;
            label = "10% discount unlocked 🎉";
        }

        return `
            <div class="bundle-progress">
                <div class="bundle-progress-bar">
                    <div class="bundle-progress-fill" style="width:${percent}%"></div>
                </div>
                <div class="bundle-progress-label">${label}</div>
            </div>
        `;
    };

    function getProgressMeta(totalCount) {
        if (totalCount === 0) return { percent: 0, label: "Add items to unlock discounts" };
        if (totalCount < 3) return { percent: (totalCount / 3) * 100, label: `${3 - totalCount} more for 5% off` };
        if (totalCount < 5) return { percent: ((totalCount - 3) / 2) * 100, label: `${5 - totalCount} more for 10% off` };

        return { percent: 100, label: "10% discount unlocked 🎉" };
    }


    function renderProgressBarBarOnly(percent) {
        return `
        <div class="bundle-progress">
            <div class="bundle-progress-bar">
                <div class="bundle-progress-fill" style="width:${percent}%"></div>
            </div>
        </div>
    `;
    }


    function renderSummary() {
        // TOTAL COUNT (units, not unique variants)
        const count = bundleItems.reduce((t, i) => t + i.qty, 0);

        // Correct subtotal calculation (qty * price)
        let subtotal = bundleItems.reduce((t, i) => t + (i.price * i.qty), 0);

        // Discount logic based on total item count
        let discountPercent = count >= 5 ? 10 : count >= 3 ? 5 : 0;
        const discountAmount = Math.round(subtotal * (discountPercent / 100));
        const total = subtotal - discountAmount;

        const { percent, label } = getProgressMeta(count);

        // Row showing subtotal and discounted total
        const priceRow = discountPercent > 0
            ? `<p><strong>Subtotal</strong> <span class="price"><span class="old-price">£${(subtotal / 100).toFixed(2)}</span> £${(total / 100).toFixed(2)}</span></p>`
            : `<p><strong>Subtotal</strong> £${(subtotal / 100).toFixed(2)}</p>`;

        bundleSummaryContent.innerHTML = `
        <div class="summary-header-row">
            ${renderSummaryThumbnails()}
            ${bundleItems.some(i => i.outOfStock)
                ? `<p class="bundle-summary-warning">⚠️ One or more items in your bundle are no longer available.</p>`
                : ""
            }
            <div class="progress-label-inline">${label}</div>
        </div>

        ${renderProgressBarBarOnly(percent)}

        <p><strong>Discount</strong> ${discountPercent}% (£${(discountAmount / 100).toFixed(2)})</p>
        ${priceRow}

        <button id="bundle-checkout-btn" class="bundle-checkout-btn" ${count === 0 ? "disabled" : ""}>
            Checkout Bundle
        </button>
    `;
    }



    const updateUI = () => {
        renderBundle();
        renderSummary();
        updateCarouselState();
    };

    // Load saved bundle from session storage
    const savedBundle = sessionStorage.getItem("bundleItems");
    if (savedBundle) {
        try {
            bundleItems = JSON.parse(savedBundle);
        } catch (e) {
            bundleItems = [];
        }
    }

    // ⭐ Normalize old items (VERY important)
    bundleItems = bundleItems.map(i => ({
        ...i,
        qty: i.qty ? Number(i.qty) : 1,
        unitOutOfStock: i.unitOutOfStock || []

    }));

    checkBundleStock();


    updateUI();


    function updateCarouselState() {
        const wrapper = document.querySelector("#bundle-items-wrapper");
        const arrows = document.querySelector("#bundle-carousel-arrows");

        if (!wrapper || !arrows) return;

        if (bundleItems.length > 3) {
            wrapper.classList.add("carousel-active");
            arrows.style.opacity = "1";
            arrows.style.pointerEvents = "auto";
        } else {
            wrapper.classList.remove("carousel-active");
            arrows.style.opacity = "0";
            arrows.style.pointerEvents = "none";
        }
    }

    document.addEventListener("click", e => {
        if (e.target.classList.contains("bundle-arrow-left"))
            document.querySelector("#bundle-items")
                .scrollBy({ left: -300, behavior: "smooth" });

        if (e.target.classList.contains("bundle-arrow-right"))
            document.querySelector("#bundle-items")
                .scrollBy({ left: 300, behavior: "smooth" });
    });

    document.addEventListener("variant:change", event => {
        const quickview = event.target.closest("popup-modal");
        if (!quickview) return;

        const priceEl = quickview.querySelector("[data-product-price]");
        if (priceEl) priceEl.setAttribute("data-raw-price", event.detail.variant.price);
    });

    document.addEventListener("click", e => {
        const btn = e.target.closest(".add-to-bundle-btn");
        if (!btn) return;

        const quickview = btn.closest("popup-modal");
        if (!quickview) return;

        const handle = btn.dataset.productHandle;
        const variantId = quickview.querySelector("input[name='id']").value;
        const title = quickview.querySelector(".product-summary__title")?.innerText.trim() || "";
        const priceText = quickview.querySelector(".product-summary__price [data-price]")?.innerText || "£0";
        const price = Math.round(parseFloat(priceText.replace(/[^0-9.]/g, "")) * 100);
        const image = quickview.querySelector("img")?.src || "";

        const card = document.querySelector(`[data-product-handle="${handle}"]`);
        const variants = JSON.parse(card.dataset.variants);
        const variantObj = variants.find(v => v.id == variantId);

        const existing = bundleItems.find(i => i.variantId == variantId);

        // ⭐ FIXED STOCK CHECK ⭐
        if (existing && existing.qty >= variantObj.inventory) {
            return; // UI will disable this instead of alerting
        }

        if (existing) {
            existing.qty += 1;          // ← ADD second unit correctly
        } else {
            bundleItems.push({
                handle,
                variantId,
                title,
                price,
                image,
                qty: 1,
                unitOutOfStock: []   // NEW: tracks per-unit availability
            });

        }

        sessionStorage.setItem("bundleItems", JSON.stringify(bundleItems));

        updateUI();
        quickview.querySelector(".popup-modal__close")?.click();
    });


    document.addEventListener("click", e => {
        const btn = e.target.closest(".bundle-remove-x");
        if (!btn) return;

        const variantId = btn.dataset.variantId;

        const item = bundleItems.find(i => i.variantId === variantId);
        if (!item) return;

        if (item.qty > 1) {
            // Reduce quantity by ONE (do not remove entire item)
            item.qty -= 1;
        } else {
            // Remove item entirely
            const index = bundleItems.findIndex(i => i.variantId === variantId);
            if (index !== -1) bundleItems.splice(index, 1);
        }

        saveBundle();
        updateUI();
    });


    const autoAddHandle = getURLParam("add");
    const autoAddVariant = getURLParam("variant");

    if (autoAddHandle) {
        const card = document.querySelector(
            `[data-product-handle="${autoAddHandle}"]`
        );

        if (card) {
            let variants = [];
            try {
                variants = JSON.parse(card.dataset.variants);
            } catch { }

            // STEP 1 — Try matching the variant passed in URL
            let chosenVariant = null;

            if (autoAddVariant) {
                chosenVariant = variants.find(
                    v => String(v.id) === String(autoAddVariant)
                );
            }

            // STEP 2 — If variant missing or invalid → fallback to first available
            if (!chosenVariant) {
                chosenVariant = variants.find(v => v.available);
            }

            if (chosenVariant) {
                // Check if this variant already exists in the bundle
                let existing = bundleItems.find(
                    i => i.variantId == chosenVariant.id
                );

                if (existing) {
                    // Increase quantity ONLY if stock allows
                    if (existing.qty < chosenVariant.inventory) {
                        existing.qty += 1;
                    }
                } else {
                    // Add new item
                    bundleItems.push({
                        handle: autoAddHandle,
                        variantId: chosenVariant.id,
                        title: card.dataset.productTitle || autoAddHandle,
                        price: Number(chosenVariant.price),
                        image: chosenVariant.image || card.dataset.productImage,
                        qty: 1,
                        outOfStock: false,
                        unitOutOfStock: []   // keep your unit tracking system
                    });
                }

                saveBundle();
                updateUI();
            }
        }
    }



});

document.addEventListener("click", async e => {
    const btn = e.target.closest("#bundle-checkout-btn");
    if (!btn) return;

    if (bundleItems.length === 0) return alert("Please add at least one item");

    // Block checkout if ANY item is invalid
    const invalidItems = bundleItems.filter(i => i.outOfStock);

    if (invalidItems.length > 0) {
        alert("One or more items in your bundle are no longer available. Please remove or replace them before checking out.");
        return;
    }


    let discountCode =
        bundleItems.length >= 5 ? "BUNDLE10" :
            bundleItems.length >= 3 ? "BUNDLE5" : "";

    await fetch("/cart/clear.js", { method: "POST" });

    for (let item of bundleItems) {
        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: item.variantId,
                quantity: item.qty    // << THE FIX
            })
        });
    }


    window.location.href = discountCode ? `/checkout?discount=${discountCode}` : "/checkout";
});

const quickviewObserver = new MutationObserver(() => {
    const quickview = document.querySelector(".popup-modal-quickview:not(.inactive)");
    if (!quickview) return;

    const summary = quickview.querySelector(".product-summary__action");
    if (!summary) return;

    if (quickview.querySelector(".bundle-condition-picker")) return;

    const template = document.querySelector("#condition-dropdown-template");
    if (!template) return;

    const picker = template.content.cloneNode(true);
    const list = picker.querySelector(".product-option-picker__list");
    const chosen = picker.querySelector(".product-option-picker-chosen__value");

    const btn = quickview.querySelector(".add-to-bundle-btn");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    const card = document.querySelector(`[data-product-handle="${handle}"]`);
    if (!card) return;

    let variants = [];
    try { variants = JSON.parse(card.dataset.variants); }
    catch { return; }

    // Build a count-per-variant from bundleItems
    const countMap = {};
    bundleItems.forEach(i => {
        const qty = i.qty ? Number(i.qty) : 1;
        countMap[i.variantId] = (countMap[i.variantId] || 0) + qty;
    });


    variants.forEach(v => {
        // How many of THIS variant are already in the bundle?
        const countInBundle = countMap[v.id] || 0;

        // Max stock according to Shopify
        const maxStock = v.inventory ?? 1;

        // Should this variant be disabled?
        const fullyUsed = countInBundle >= maxStock;

        // Create LI wrapper
        const li = document.createElement("li");
        li.className = "product-option-picker__list-item";
        li.dataset.optionValue = v.condition;
        li.tabIndex = 0;

        // Create radio
        const input = document.createElement("input");
        input.type = "radio";
        input.name = "Condition-quickview";
        input.value = v.condition;
        input.dataset.id = v.id;


        if (!v.available) {
            li.classList.add("disabled");
            input.disabled = true;
        }

        // Rule 2: User already used all stock in bundle
        if (fullyUsed) {
            li.classList.add("disabled");
            input.disabled = true;
        }

        const label = document.createElement("div");
        label.classList.add("product-option-label");

        label.innerHTML = `
       <span class="product-option-label__value">Condition: ${v.condition}</span>

        <svg width="18" height="13" viewBox="0 0 18 13">
            <path d="M1 6.5L6 11.5L17 0.5"></path>
        </svg>
    `;

        // Add badge if user has at least one of this variant
        if (countInBundle > 0) {
            label.innerHTML += `<span class="bundle-badge">Already in your bundle</span>`;
        }

        li.appendChild(input);
        li.appendChild(label);
        list.appendChild(li);


        li.addEventListener("click", () => {
            if (input.disabled) return; // ignore disabled items

            // Remove previous selected
            list.querySelectorAll(".chosen").forEach(x => x.classList.remove("chosen"));
            li.classList.add("chosen");
            input.checked = true;

            // Update chosen text
            chosen.textContent = v.condition;

            // Update hidden variant ID
            const idInput = quickview.querySelector("input[name='id']");
            if (idInput) idInput.value = v.id;

            // Update price display
            const priceEl = quickview.querySelector(".product-summary__price [data-price]");
            if (priceEl) priceEl.textContent = `£${(v.price / 100).toFixed(2)}`;

            // Update product image
            const img = quickview.querySelector(".product-media img");
            if (img && v.image) img.src = v.image;

            // Update stars
            updateConditionStars(quickview, parseInt(v.condition));
        });
    });
    const firstEnabled = list.querySelector("li:not(.disabled)");
    if (firstEnabled) {
        const cond = firstEnabled.dataset.optionValue;
        chosen.textContent = `Condition: ${cond}`;
        firstEnabled.classList.add("chosen");

        const input = firstEnabled.querySelector("input");
        if (input) input.checked = true;

        const idInput = quickview.querySelector("input[name='id']");
        if (idInput) idInput.value = input.dataset.id;
    }

    // Insert picker into Quickview
    summary.prepend(picker);

    // Move picker above description
    const qp = quickview.querySelector(".product-option-picker");
    const desc = quickview.querySelector(".product-summary__description");
    if (qp && desc) {
        desc.parentNode.insertBefore(qp, desc);
    }
});

quickviewObserver.observe(document.body, { childList: true, subtree: true });

let isDown = false;
let startX;
let scrollLeft;

document.addEventListener("mousedown", e => {
    const slider = document.querySelector(".bundle-items-row");
    if (!slider || !slider.contains(e.target)) return;

    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
});

document.addEventListener("mouseup", () => (isDown = false));

document.addEventListener("mousemove", e => {
    if (!isDown) return;

    const slider = document.querySelector(".bundle-items-row");
    if (!slider) return;

    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    slider.scrollLeft = scrollLeft - (x - startX) * 1.3;
});


document.addEventListener("DOMContentLoaded", () => {

    const panel = document.querySelector(".bundle-slide-panel");
    const openBtn = document.getElementById("bundle-mobile-toggle");
    const closeBtn = document.getElementById("bundle-mobile-close");

    if (openBtn) {
        openBtn.addEventListener("click", () => {
            panel.classList.add("open");
            document.body.classList.add("bundle-open");   // ADDED
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            panel.classList.remove("open");
            document.body.classList.remove("bundle-open");  // ADDED
        });
    }

});


function updateConditionStars(quickview, conditionValue) {
    const stars = quickview.querySelectorAll(".condition-setting .star");
    if (!stars.length) return;

    stars.forEach((star, index) => {
        if (index < conditionValue) {
            star.classList.add("full");
            star.classList.remove("empty");
        } else {
            star.classList.add("empty");
            star.classList.remove("full");
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {

    if (document.body.classList.contains("bundle-builder-active")) {
        document.querySelectorAll(".product__quickview [data-text] span")
            .forEach(el => el.textContent = "Add to Bundle");
    }

});

const toggleBtn = document.getElementById("bundle-mobile-toggle");
const filter = document.querySelector(".facet-filters-content");

if (toggleBtn && filter) {
    new MutationObserver(() => {
        toggleBtn.style.display = filter.classList.contains("active") ? "none" : "";
    }).observe(filter, { attributes: true });
}

function checkBundleStock() {

    // flatten units
    const flat = [];
    bundleItems.forEach(item => {
        for (let i = 0; i < item.qty; i++) {
            flat.push({
                variantId: item.variantId,
                handle: item.handle,
                itemRef: item,
                unitIndex: i
            });
        }
    });

    // group by variant
    const grouped = {};
    flat.forEach(u => {
        if (!grouped[u.variantId]) grouped[u.variantId] = [];
        grouped[u.variantId].push(u);
    });

    // evaluate stock
    Object.keys(grouped).forEach(variantId => {
        const units = grouped[variantId];

        const card = document.querySelector(`[data-product-handle="${units[0].handle}"]`);
        if (!card) return;

        let variants = [];
        try { variants = JSON.parse(card.dataset.variants); } catch { }

        const variant = variants.find(v => v.id == variantId);
        if (!variant) {
            units.forEach(u => u.itemRef.unitOutOfStock[u.unitIndex] = true);
            return;
        }

        const inventory = variant.inventory ?? 0;

        // assign per-unit flags
        units.forEach((u, index) => {
            u.itemRef.unitOutOfStock[u.unitIndex] = index >= inventory;
        });
    });
}


document.addEventListener("variant:change", e => {
    const newVariant = e.detail.variant;
    if (!newVariant) return;

    // CTA button on product page
    const cta = document.getElementById("bundle-product-cta");
    if (!cta) return;

    const handle = cta.dataset.handle;
    const variantId = newVariant.id;

    // Store updated variant ID
    cta.dataset.variant = variantId;

    // Update click behaviour dynamically
    cta.onclick = () => {
        window.location.href =
            `/collections/bundle-builder-products?add=${handle}&variant=${variantId}`;
    };
});

document.addEventListener("DOMContentLoaded", () => {
    const cta = document.getElementById("bundle-product-cta");
    if (!cta) return;

    const handle = cta.dataset.handle;
    const variantId = cta.dataset.variant;

    cta.onclick = () => {
        window.location.href =
            `/collections/bundle-builder-products?add=${handle}&variant=${variantId}`;
    };
});



function updateConditionLabels(variant) {
    if (!variant) return;

    const selectedCondition = variant.option1;

    // 1️⃣ Update the visible dropdown label
    const chosen = document.querySelector(".product-option-picker-chosen__value");
    if (chosen) {
        chosen.textContent = `Condition: ${selectedCondition}`;
    }

    // 2️⃣ Update each item in the dropdown list
    document.querySelectorAll(".product-option-label__value").forEach(label => {
        const raw = label.dataset.rawValue || label.textContent.trim();
        label.dataset.rawValue = raw; // store original number once
        label.textContent = `Condition: ${raw}`;
    });
}

// On load
document.addEventListener("DOMContentLoaded", () => {
    const select = document.querySelector("select[name='id']");
    if (!select) return;

    const initialVariant = window?.product?.variants?.find(v => v.id == select.value);
    updateConditionLabels(initialVariant);
});

// On variant change
document.addEventListener("variant:change", event => {
    updateConditionLabels(event.detail.variant);
});


document.addEventListener('DOMContentLoaded', () => {
    const p = document.getElementById('enquire-popup');
    document.querySelectorAll('.enquire').forEach(b => b.onclick = () => p.style.display = 'flex');
    document.querySelector('.enquire-close').onclick = () => p.style.display = 'none';
    p.onclick = e => { if (e.target === p) p.style.display = 'none' };
});



function updateWishlistCount() {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const countElement = document.getElementById("wishlist-count");

    if (countElement) {
        countElement.textContent = wishlist.length;
    }
}
document.addEventListener("DOMContentLoaded", updateWishlistCount);
document.addEventListener("click", (e) => {
    if (e.target.closest(".heart")) {
        setTimeout(updateWishlistCount, 50);
    }
});
